import { ShopContext } from '../Context/ShopContext';
import { roundOff } from 'helpers/NumberFormatHelper';
import { TAX_PREFERENCE } from 'const';
import { useContext } from 'react';

export const TaxHelper = () => {
  const { shop } = useContext(ShopContext);

  const getItemUnitRate = (item, cartItem = {}) => {
    const { tax, cess } = item;
    const price = cartItem?.price ?? item.price;

    if (shop?.tax_preference === TAX_PREFERENCE.INCLUDING_TAX) {
      let taxDeducted = (price * 100) / (tax + 100);
      return roundOff((taxDeducted * 100) / (cess + 100));
    }
    return price;
  };

  const getItemUnitRateByPayable = (item = {}) => {
    const { tax = 0, cess = 0, payable = 0, quantity = 1 } = item;

    if (!payable || quantity === 0) return 0;

    const taxMultiplier = 1 + tax / 100;
    const cessMultiplier = 1 + cess / 100;
    const unitTotal = payable / quantity;
    const price = unitTotal / (taxMultiplier * cessMultiplier);

    return roundOff(price);
  };

  const getItemUnitRateWithTax = (item) => {
    const { price, tax, cess } = item;

    if (shop?.tax_preference === TAX_PREFERENCE.INCLUDING_TAX) {
      let priceWithCess = (price * (cess + 100)) / 100;
      return roundOff((priceWithCess * (tax + 100)) / 100);
    }
    return price;
  };

  const getItemCess = (item) => {
    const price = item.itemAmount ?? roundOff(item.quantity * item.rate);
    return roundOff((price * item.cess) / 100);
  };

  const getItemTax = (item) => {
    const price = item.itemAmount ?? roundOff(item.quantity * item.rate);
    const cess = getItemCess(item);
    let tax = 0;

    if ([TAX_PREFERENCE.INCLUDING_TAX, TAX_PREFERENCE.EXCLUDING_TAX].includes(shop?.tax_preference)) {
      tax = ((price + cess) * item.tax) / 100;
    }

    return roundOff(tax);
  };

  return {
    getItemUnitRate,
    getItemUnitRateByPayable,
    getItemUnitRateWithTax,
    getItemCess,
    getItemTax,
  };
};
